export const SUPPORTED_IMAGE_EXTENSIONS = [".jpg", ".jpeg"];
export const SUPPORTED_VIDEO_EXTENSIONS = [".mp4", ".insv"];
export const SUPPORTED_POINTCLOUD_EXTENSIONS = [".ply", ".las", ".laz"];

export const ASPECT_RATIO_ALLOWED_ERROR = .05;

// File limits for different input types
export const FILE_LIMITS = {
  VIDEO: 5,
  IMAGES: 50,
  POINTCLOUD: 10,
  GPX: 5,
  STILL_IMAGES: 20,
  CUSTOM_ADDITIONAL: 10,
};

export const MATRIX = [
  [1, 0, 0, 0],
  [0, 1, 0, 0],
  [0, 0, 1, 0],
  [0, 0, 0, 1],
];

export const STATE_COLORS = {
  error: {
    bgColor: '#672923',
  },
  warn: {
    bgColor: '#6b5911',
  },
  info: {
    bgColor: '#253565',
  },
  success: {
    bgColor: '#295326',
  },
} as const;

// SolarSquare workspace identifiers
export const SOLARSQUARE_WORKSPACES_IDS = [
  // test ws in dev
  '84e18e52-3242-455e-b019-ff7e9d431a77',
  // the two actual solar square ws in prod
  'b67740c1-96b2-49ee-a9ae-a4c55162e9d8',
  '57a7278f-12ee-4203-ae24-deb1cc646da4'
];

export const M_TO_FT_CONVERSION_FACTOR = 3.28084;